import { Button, Flex, Popover, Tag, Tooltip, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import {
  getPayoutAdminNote,
  isPayoutRejected,
  payoutStatusColor,
} from "../../utils/payoutDisplay";

const { Paragraph } = Typography;

type PayoutStatusCellProps = {
  status?: string;
  record: Record<string, unknown>;
};

export default function PayoutStatusCell({ status, record }: PayoutStatusCellProps) {
  const label = status || "N/A";
  const adminNote = getPayoutAdminNote(record);
  const showAdminNote = isPayoutRejected(label) && adminNote;

  return (
    <Flex align="center" gap={8} wrap="nowrap">
      <Tag
        color={
          payoutStatusColor[label.toLowerCase()] ||
          (label === "approved"
            ? "success"
            : label === "pending"
              ? "warning"
              : "default")
        }
        className="capitalize !m-0"
      >
        {label}
      </Tag>
      {showAdminNote && (
        <Popover
          title="Admin note"
          trigger="click"
          placement="leftTop"
          content={
            <Paragraph
              className="!mb-0 !text-[13px] !text-gray-700 whitespace-pre-wrap break-words"
              style={{ maxWidth: 320 }}
            >
              {adminNote}
            </Paragraph>
          }
        >
          <Tooltip title="View admin note">
            <Button
              danger
              type="text"
              size="small"
              icon={<InfoCircleOutlined style={{ fontSize: 14 }} />}
              aria-label="View admin note"
              style={{ width: 24, height: 24, minWidth: 24, padding: 0 }}
            />
          </Tooltip>
        </Popover>
      )}
    </Flex>
  );
}
